export default {
  substoreCodes: [
    'ACCESS_DENIED',
    'PRODUCT_CANNOT_BE_FINALIZED_BECAUSE_OF_EXISTING_RETRY_ENTRY',
    'PRODUCT_ALREADY_FINALIZED',
    'PRODUCT_CANNOT_BE_FINALIZED_BECAUSE_OF_MISSING_DESC_ELEMENTS',
    'VERIFICATION_OF_BASE_PRODUCT_NOT_POSSIBLE',
    'PRODUCT_CANNOT_BE_FINALISED_BY_PORTAL',
    'PRODUCT_ALREADY_BOOKED',
    'PRODUCT_NOT_BOOKABLE_BECAUSE_EXCLUDED_SUBTEMPID',
    'NO_PERMISSION_FOR_CATALOGUE',
    'OPTIN_NOT_POSSIBLE',
    'NO_PERMISSION_FOR_MYPRODUCTS',
    'CUSTOMER_DATA_RETRIEVAL_NOT_POSSIBLE',
    'CAS_VERIFICATION_FAILED',
    'SSO_USER_INFO_FAILED',
    'NO_OPENID_TOKEN_RESPONSE',
    'INVALID_NONCE_VALUE',
    'WRONG_ID_TOKEN_AUDIENCE',
    'INVALID_TOKEN_SIGNATURE',
    'UNSUPPORTED_HASH_ALG',
    'EXPIRED_ID_TOKEN',
    'COLP_PURCHASE_PRODUCT_FAILED',
    'ZPI_CREATE_ACCOUNT_FAILED',
    'ZPI_SET_FEATURES_FAILED',
    'ACCESS_TOKEN_COULD_NOT_BE_RETRIEVED',
  ],
  xtcCodes: ['BARRING_PROFILE_TYPE_NOT_SUPPORTED', 'BARRING_PROFILE_MISCONFIGURATION'],
};
